
import { useState } from 'react';

export default function Mission() {
  const [expandedCard, setExpandedCard] = useState<number | null>(1);

  const missions = [
    {
      id: 0,
      title: 'Faithful Ranching',
      description: 'We practice biblical stewardship in every aspect of cattle management, treating our longhorns with respect and care as God\'s creation.',
      extended: 'Our ranching practices are rooted in scripture and guided by prayer. We believe in sustainable, ethical treatment of our cattle, ensuring they live healthy, dignified lives. Through our work, we demonstrate that faith and agriculture can work hand in hand.',
      bgColor: 'bg-[#FFE4E1]',
      image: 'https://public.readdy.ai/ai/img_res/c330c167ae3de20a3a4095a1c8590314.jpg'
    },
    {
      id: 1,
      title: 'Community Outreach',
      description: 'Supporting local families and churches through food donations, educational programs, and fellowship opportunities.',
      extended: 'We partner with churches and community organizations to provide beef donations to families in need, host ranch tours for youth groups, and create spaces for fellowship. Our mission extends beyond the ranch to touch hearts throughout our region.',
      bgColor: 'bg-[#E8F5E9]',
      image: 'https://readdy.ai/api/search-image?query=diverse%20community%20gathering%20at%20ranch%20with%20families%20and%20children%20learning%20about%20cattle%20volunteers%20serving%20food%20joyful%20fellowship%20scene%20with%20longhorns%20in%20background%20warm%20community%20spirit%20with%20mint%20green%20and%20natural%20tones&width=600&height=800&seq=mission002&orientation=portrait'
    },
    {
      id: 2,
      title: 'Faith Education',
      description: 'Teaching biblical values and life lessons through hands-on ranching experiences and mentorship programs.',
      extended: 'Young people learn responsibility, hard work, and faith through our mentorship programs. We use ranching as a living classroom to teach biblical principles, character development, and the importance of serving others with a grateful heart.',
      bgColor: 'bg-[#F5E6D3]',
      image: 'https://readdy.ai/api/search-image?query=youth%20group%20learning%20at%20ranch%20with%20mentor%20teaching%20children%20about%20longhorn%20cattle%20educational%20outdoor%20setting%20with%20cross%20visible%20inspiring%20faith%20based%20learning%20experience%20with%20warm%20beige%20and%20brown%20tones&width=600&height=800&seq=mission003&orientation=portrait'
    }
  ];

  return (
    <section className="bg-white py-24">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-20">
          <h2 className="text-5xl font-bold text-[#3E2723] mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
            Our Mission ✝ Three Pillars of Purpose
          </h2>
        </div>

        {/* Three Column Cards */}
        <div className="grid grid-cols-3 gap-8">
          {missions.map((mission) => (
            <div
              key={mission.id}
              className={`${mission.bgColor} rounded-2xl overflow-hidden cursor-pointer transition-all duration-300 ${
                expandedCard === mission.id ? 'scale-110 shadow-2xl' : 'hover:scale-105 shadow-lg'
              }`}
              onMouseEnter={() => setExpandedCard(mission.id)}
              onMouseLeave={() => setExpandedCard(null)}
            >
              <div className="relative h-96">
                <img 
                  src={mission.image} 
                  alt={mission.title} 
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-8 text-white">
                  <h3 className="text-3xl font-bold mb-3">{mission.title}</h3>
                  <p className="text-base leading-relaxed">
                    {expandedCard === mission.id ? mission.extended : mission.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
